@if (contentReady() == 'input') {
  <div
    class="flex flex-col items-center content-center w-full h-full space-y-4"
  >
    @if (!twoFactorType()) {
      <span class="w-full pb-4 text-3xl font-semibold text-center text-white">{{
        'Welcome back' | siaTranslate
      }}</span>
      <form (ngSubmit)="login()" class="w-full space-y-4">
        <mat-form-field
          class="w-full sia-login"
          appearance="outline"
          subscriptSizing="dynamic"
        >
          <mat-label>{{ 'Username o Email' | siaTranslate }}</mat-label>
          <input
            matInput
            id="userIdentifier"
            name="userIdentifier"
            autocomplete="username"
            [ngModel]="userIdentifier()"
            (ngModelChange)="userIdentifier.set($event)"
            type="text"
            [disabled]="loginStarted()"
          />
        </mat-form-field>
        <mat-form-field
          class="w-full sia-login"
          appearance="outline"
          subscriptSizing="dynamic"
        >
          <mat-label>{{ 'Password' | siaTranslate }}</mat-label>
          <input
            #passwordInput
            class="auth-input"
            matInput
            [type]="hide() ? 'password' : 'text'"
            id="password"
            name="password"
            autocomplete="current-password"
            [ngModel]="password()"
            (ngModelChange)="password.set($event)"
            [disabled]="loginStarted()"
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="passwordToggle($event)"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide()"
          >
            <mat-icon>{{ hide() ? 'visibility' : 'visibility_off' }}</mat-icon>
          </button>
        </mat-form-field>
        <button
          mat-flat-button
          class="w-full secondary"
          [disabled]="loginStarted()"
          type="submit"
        >
          @if (loginStarted()) {
            <i class="fa fa-spinner fa-spin"></i>
          }
          {{ 'Accedi' | siaTranslate }}
        </button>
      </form>
      <div class="auth-info">
        <button
          mat-button
          [style]="{ color: 'white !important' }"
          [routerLink]="'/auth/request-password'"
          [disabled]="loginStarted()"
        >
          {{ 'Password dimenticata?' | siaTranslate }}
        </button>
      </div>
      @if (microsoftLoginAvailable()) {
        <div class="flex items-center w-full gap-3">
          <div class="flex-1 h-px bg-white/30"></div>
          <span class="text-sm text-white/70">{{
            'oppure' | siaTranslate
          }}</span>
          <div class="flex-1 h-px bg-white/30"></div>
        </div>
        <microsoft-auth-button
          mode="auth"
          variant="stroked-button"
          theme="dark"
          class="w-full"
          [disabled]="loginStarted()"
          (authResult)="onMicrosoftAuthResult($event)"
        />
      }
    } @else {
      <span class="w-full pb-4 text-3xl font-semibold text-center text-white">{{
        'Inserire il pin temporaneo' | siaTranslate
      }}</span>
      <form (ngSubmit)="login()">
        <mat-form-field
          class="w-full sia-login"
          appearance="outline"
          subscriptSizing="dynamic"
        >
          <mat-label>{{ 'Codice OTP' | siaTranslate }}</mat-label>
          <input
            matInput
            [ngModel]="otp()"
            name="otp"
            type="text"
            autocomplete="one-time-code"
            (ngModelChange)="onOtpChange($event)"
          />
        </mat-form-field>
        <div class="flex flex-col items-center w-full gap-2 mt-2">
          @if (twoFactorType() == 'email') {
            <p
              class="w-full text-sm text-center"
              (click)="buttonDisable() ? null : sendNewPin()"
              [style.opacity]="buttonDisable() ? 0.5 : 1"
              [class.cursor-not-allowed]="buttonDisable()"
              [class.cursor-pointer]="!buttonDisable()"
            >
              {{ 'Richiedi codice in ' | siaTranslate }} {{ minutes() }}:{{
                seconds2Digits()
              }}
            </p>
          }
          <button
            mat-flat-button
            [disabled]="isOtpInvalid()"
            class="w-full secondary"
            type="submit"
          >
            @if (loginStarted()) {
              <i class="fa fa-spinner fa-spin"></i>
            }
            {{ 'Conferma' | siaTranslate }}
          </button>
        </div>
      </form>

      <div class="auth-info">
        <button
          mat-button
          [style]="{ color: 'white !important' }"
          (click)="twoFactorType.set('')"
        >
          {{ 'Cambia utente' | siaTranslate }}
        </button>
      </div>
    }
  </div>
}
@if (contentReady() == 'auto') {
  <div class="flex flex-col items-center justify-center space-y-4">
    <mat-spinner></mat-spinner>
    <span class="text-2xl text-center">{{
      'Ti stiamo connettendo al portale' | siaTranslate
    }}</span>
  </div>
}
